import { AfterViewInit, Component, HostListener, signal } from '@angular/core';

@Component({
  selector: 'app-menu-purchase',
  imports: [],
  templateUrl: './menu-purchase.html',
  styleUrl: './menu-purchase.scss',
})
export class MenuPurchase implements AfterViewInit {
  public isMobile = signal(false);

  ngAfterViewInit(): void {
    this.onResize();
  }

  @HostListener('window:resize', [])
  onResize(): void {
    if (typeof window !== 'undefined') {
      this.isMobile.set(window.innerWidth <= 992);
    }
  }

  closeMenu() {
    if (typeof document !== 'undefined') {
      const display = document.getElementById('menu-purchase') as HTMLElement;
      display.style.display = 'none';
    }
  }

  closeMenuMovil() {
    if (typeof document !== 'undefined') {
      const display = document.getElementById('menuPurchase') as HTMLElement;
      display.setAttribute('style', 'display: none');
      document.body.style.overflowY = 'auto';
    }
  }
}
